import React from 'react'
import {FiLoader} from 'react-icons/fi'
export default function() {
  return (
    <div className='loader'>
        <FiLoader className="icon animated infinite spin slow"/>
    </div>
  )
}
